import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'

import './styles.scss'
import {ResponsiveContainer, Cell} from "../ResponsiveGrid/index"
import Img from 'gatsby-image'
import extractContent, {CONTENT_TYPE_HTML, CONTENT_TYPE_IMAGE, CONTENT_TYPE_OPTIMISE_IMAGE } from '../../helpers/extractContent'

class Header extends Component {

  static propTypes = {
    size: PropTypes.oneOf(['xlarge', 'large', 'medium', 'small'])
  }

  static contextTypes = {
    staticData: PropTypes.array,
  }

  render () {
    const {
      staticData
    } = this.context

    const {
      contentID,
      className,

      contentText,
      contentImage,

      size,
    } = this.props

    const finalClassName = cx("Atrakeur-Header", {
      [`Atrakeur-Header--${size}`]: size,
    }, className)

    const contentFinalImage = !contentImage ? extractContent(contentID, CONTENT_TYPE_OPTIMISE_IMAGE, staticData): contentImage
    const contentFinalText = !contentText ? extractContent(contentID, CONTENT_TYPE_HTML, staticData): contentText

    return (
      <header className={finalClassName}>
        { contentFinalImage && <Img sizes={ contentFinalImage } /> }
        { contentFinalText && <ResponsiveContainer className="Atrakeur-Header-Title">
          <Cell
            colSpanDesktop="6"
            colSpanTablet="4"
            colSpanMobile="4"
          >
            <div
              dangerouslySetInnerHTML={{ __html: contentFinalText }}
            />
          </Cell>
        </ResponsiveContainer> }
      </header>
    )
  }
}
export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js